import PeopleIcon from "Assets/SVG/PeopleIcon";
import PageLayout from "Layouts/PageLayout";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import {useDeleteUser, useUser} from "Apis/UsersApi";
import { UsersForm } from "Features/Users";
import Button from "../../Components/Button";
import XIcon from "../../Assets/SVG/XIcon";

const Edit = () => {
    
    const { t } = useTranslation();
    
    const { id } = useParams();
    
    const { data: user } = useUser(parseInt(id!));
    const { mutateAsync: deleteUserMutation, isLoading: isDeletingUser} = useDeleteUser();
    
    const navigate = useNavigate();

    const deleteUser = async () => {
        await deleteUserMutation(user!);

        navigate(-1);
    }
    
    return (
        <PageLayout title={t('updateUser')} icon={<PeopleIcon />} includeBox header={(
            <Button type={"secondary"} loading={isDeletingUser} prefix={<XIcon fill={"#FFF"} />} text={t("deleteUser")} onClick={deleteUser} />
        )}>
            <UsersForm user={user} onSubmit={_ => navigate(-1)} />
        </PageLayout>
    )
}

export default Edit;
